var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pp-modal",
    {
      attrs: { "mask-closable": false, width: "368", closable: false },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c("div", { staticClass: "modalhead" }, [
        _c("div", {}, [_vm._v("流水详情1")]),
        _c("div", { staticClass: "secondTitle" }, [
          _vm._v("流水号:LS201709121145041004"),
        ]),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "line" }, [
          _c("div", { staticClass: "fl" }, [_vm._v("业务类型")]),
          _c("div", { staticClass: "fr" }, [_vm._v("保证金入账")]),
        ]),
        _c("div", { staticClass: "line" }, [
          _c("div", { staticClass: "fl" }, [_vm._v("来源网站订单号")]),
          _c("div", { staticClass: "fr" }, [_vm._v("24543234235")]),
        ]),
        _c("div", { staticClass: "line" }, [
          _c("div", { staticClass: "fl" }, [_vm._v("交易流水号")]),
          _c("div", { staticClass: "fr" }, [_vm._v("24543234235_bzj")]),
        ]),
        _c("div", { staticClass: "line" }, [
          _c("div", { staticClass: "fl" }, [_vm._v("入账金额")]),
          _c("div", { staticClass: "fr" }, [_vm._v("2,013.00 USD")]),
        ]),
        _c("div", { staticClass: "line" }, [
          _c("div", { staticClass: "fl" }, [_vm._v("产生费用")]),
          _c("div", { staticClass: "fr" }, [_vm._v("0 USD")]),
        ]),
        _c("div", { staticClass: "line" }, [
          _c("div", { staticClass: "fl" }, [_vm._v("入账时间")]),
          _c("div", { staticClass: "fr" }, [_vm._v("2017-10-18 20:33:22")]),
        ]),
        _c("div", { staticClass: "bankline" }, [
          _c("img", { attrs: { src: "/static/imgs/login/logo.png" } }),
          _c("div", { staticClass: "info" }, [
            _c("div", [_vm._v("招商银行")]),
            _c("div", [_vm._v("1234 **** **** 1234")]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "textright", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "pp-button",
            {
              staticClass: "modal-btn",
              attrs: { type: "primary", size: "spec" },
              on: { click: _vm.sure },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }